import { render, staticRenderFns } from "./MiniPaper.vue?vue&type=template&id=3f2e95bf&scoped=true&"
import script from "./MiniPaper.vue?vue&type=script&lang=js&"
export * from "./MiniPaper.vue?vue&type=script&lang=js&"
import style0 from "./miniPaper.scss?vue&type=style&index=0&id=3f2e95bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e95bf",
  null
  
)

export default component.exports